import { SelectModelPage } from '../containers/selectModelPage';
import { TechDocChecklistPage, TechDocWizardPage, TechDocPage } from '../containers/pages';
import {
  DHCI_RACK_VIDEO,
  DHCI_CABLE_STEP1_VIDEO,
  ALLETRAMP_VIDEO_URL,
  ALLETRA6k_VIDEO_URL,
  DHCI_SWITCH_CONFIGURE_VIDEO,
} from '../constants';
const gettingStartedPath = '/getting-started/';
const cloudEnablementPath = `${gettingStartedPath}cloud-enablement/`;
export const gettingStarted = () => {
  let config = [];
  config = gettingStartedConfig();
  return config;
};
function gettingStartedConfig() {
  const menuItemArray = [
    {
      path: '/getting-started',
      menuText: 'gettingStarted',
      exact: true,
      redirectTo: '/getting-started/select-model',
      submenuItems: [
        {
          path: '/getting-started/select-model',
          menuText: 'selectStorageTier',
          pageName: 'selectStorageTier',
          exact: true,
          component: SelectModelPage,
          pageProps: {},
        },
        {
          path: cloudEnablementPath,
          menuText: 'cloudenablement',
          exact: true,
          redirectTo: `${cloudEnablementPath}1`,
        },
        {
          path: `${cloudEnablementPath}:step`,
          exact: true,
          component: TechDocWizardPage,
          pageName: 'cloudenablement',
          pageProps: {
            steps: [
              {
                videoUrl: '',
                steptitle: 'Getting Started',
              },
              {
                videoUrl: '',
                steptitle: 'Create User Account',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP3,
                steptitle: 'Create Workspace',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP4,
                steptitle: 'Deploy Data Services Cloud Console',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP5,
                steptitle: 'Assign Administrator',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP6,
                steptitle: 'Add the Device to Your Workspace',
              },
            ],
          },
        },
        {
          path: '/getting-started/checklist',
          menuText: 'preInstallation',
          exact: true,
          component: TechDocChecklistPage,
          pageProps: {},
        },
      ],
    },
    {
      path: '/physical-install',
      menuText: 'physicalInstallation',
      exact: true,
      redirectTo: '/physical-install/unbox',
      submenuItems: [
        {
          path: '/physical-install/unbox',
          menuText: 'unbox',
          exact: true,
          component: TechDocPage,
          pageProps: {
            videoUrl: ALLETRA6k_VIDEO_URL.DHCI_UNBOX,
          },
        },
        {
          path: '/physical-install/rackArray',
          menuText: 'rackArray',
          exact: true,
          redirectTo: '/physical-install/rackArray/1',
        },
        {
          path: '/physical-install/rackArray/:step',
          exact: true,
          component: TechDocWizardPage,
          pageName: 'rackArray',
          pageProps: {
            steps: [
              {
                videoUrl: ALLETRA6k_VIDEO_URL.DHCI_RACK_ARRAY_STEP1,
              },
              {
                videoUrl: ALLETRA6k_VIDEO_URL.DHCI_RACK_ARRAY_STEP2,
              },
              {
                videoUrl: ALLETRA6k_VIDEO_URL.DHCI_RACK_ARRAY_STEP3,
              },
            ],
          },
        },
        {
          path: '/physical-install/rackServersSwitches',
          menuText: 'rackServersSwitches',
          exact: true,
          component: TechDocPage,
          pageProps: {
            videoUrl: DHCI_RACK_VIDEO,
          },
        },
        {
          path: '/physical-install/cable',
          menuText: 'cable',
          exact: true,
          redirectTo: '/physical-install/cable/1',
        },
        {
          path: '/physical-install/cable/:step',
          exact: true,
          component: TechDocWizardPage,
          pageName: 'cable',
          pageProps: {
            steps: [
              {
                videoUrl_green: DHCI_CABLE_STEP1_VIDEO,
              },
              {
                videoUrl_green: '',
              },
              {
                videoUrl_green: '',
              },
            ],
          },
        },
        {
          path: '/physical-install/powerOn',
          menuText: 'powerOn',
          exact: true,
          component: TechDocPage,
          pageProps: {
            videoUrl: ALLETRA6k_VIDEO_URL.DHCI_POWER,
          },
        },
      ],
    },
    {
      path: '/software-config',
      menuText: 'softwareConfig',
      exact: true,
      redirectTo: '/software-config/configSwitch',
      submenuItems: [
        {
          path: '/software-config/configSwitch',
          menuText: 'configSwitch',
          exact: true,
          component: TechDocPage,
          pageProps: {
            videoUrl_green: DHCI_SWITCH_CONFIGURE_VIDEO,
          },
        },
        {
          path: '/software-config/prepareEnv',
          menuText: 'prepareEnv',
          exact: true,
          component: TechDocPage,
          pageProps: {},
        },
        {
          path: '/software-config/arrayDiscovery',
          menuText: 'arrayDiscovery',
          exact: true,
          component: TechDocPage,
          pageProps: {},
        },
        {
          path: '/software-config/connectArray',
          menuText: 'connectArray',
          exact: true,
          component: TechDocPage,
          pageProps: {},
        },
        {
          path: '/software-config/arraySetup',
          menuText: 'arraySetup',
          exact: true,
          component: TechDocPage,
          pageProps: {
            // contentType: 'react-showdown',
          },
        },
        {
          path: '/software-config/validation',
          menuText: 'arrayValidation',
          exact: true,
          component: TechDocChecklistPage,
          pageProps: {},
        },
        {
          path: '/software-config/completeSetup',
          menuText: 'setupComplete',
          exact: true,
          component: TechDocPage,
          pageProps: {},
        },
      ],
    },
  ];
  return menuItemArray;
}
